/**
 * Start EC-543 [FE]
 * Create a redux store for Guest RFQ
 **/

import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<{quoteCount:number}, {quoteCount:number}>;

export const BeginLoadQuoteCount: HandlerType = props => {
    props.dispatch({
        type: "Custom/GuestRFQ/BeginLoadQuoteCount",
    });
};


export const CompletedLoadQuoteCount: HandlerType = props => {
    props.dispatch({
        type: "Custom/GuestRFQ/CompletedLoadQuoteCount",
        quoteCount: props.parameter.quoteCount,
    });
};

export const chain = [BeginLoadQuoteCount, CompletedLoadQuoteCount];

const guestRFQCartHandler = createHandlerChainRunner(chain, "guestRFQCartHandler");
export default guestRFQCartHandler;

/**
 * End EC-543 [FE]
 * Create a redux store for Guest RFQ
 **/